import React from 'react'
import { Link } from 'react-router-dom'
import { Card } from './card'
import PropTypes from 'prop-types'
import { AlertEmpty } from '../../../components'

const List = ({data, bookmark}) => {
  return (
    <div className="flex flex-wrap -mx-2 lg:-mx-4">
      {
        data && data.map((d, index) => {
          return (
            <div key={index} className="w-1/2 lg:w-1/3 px-2 lg:px-4 mb-5 lg:mb-8">
              <Link to={`/resource/${d.id}/detail/${d.type ? d.type : 'book'}`}>
                <Card data={d} bookmark={bookmark}/>
              </Link>
            </div>
          )
        })
      }
      {
        (data && data.length === 0) &&
        <div className="px-2 lg:px-4">
          <AlertEmpty />
        </div>
      }
    </div>
  )
}

List.propTypes = {
  data: PropTypes.array,
  bookmark: PropTypes.bool,
}

List.defaultProps = {
  data: [],
  bookmark: false,
}


export { List }
